"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutSectionView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const GridWrap = (0, app_1.styled)(ui_1.Stack) `
  grid-gap: ${(theme) => theme.spacing.extraSmall};
  align-items: ${(_theme, { $completed }) => $completed ? 'center' : 'baseline'};
`;
const OrderNumber = app_1.styled.span `
  font-size: 1.375rem;
  font-weight: 500;
  width: ${(theme) => theme.spacing.small};
  ${(theme) => theme.flexCenter}
  color: black;
`;
const TitleWrap = (0, app_1.styled)(ui_1.Stack) `
  padding: 1.5rem 0;
  > span,
  h2 {
    color: ${(theme, { $completed }) => $completed ? '#0c1238' : theme.colors.gray} !important;
  }
  cursor: ${(_, { $completed }) => ($completed ? 'pointer' : 'unset')};
`;
const Child = (0, app_1.styled)(GridWrap) `
  > div {
    width: 100%;
  }
  label {
    margin-left: 0;
    font-size: 0.8125rem;
  }

  padding-bottom: ${(theme, { $completed }) => $completed ? 0 : theme.spacing.small};

  @media ${app_1.mobile} {
    margin-left: 0;
  }
`;
const Wrap = app_1.styled.div `
  border-bottom: 1px solid ${(theme) => theme.colors.gray.light};
`;
const StyledSvgCheck = (0, app_1.styled)(svg_1.SvgCheck) `
  color: ${(theme) => theme.colors.success};
`;
function CheckoutSectionView({ children, number, title, }) {
    const { setActivePage, activePage } = (0, ui_1.useFormContext)();
    const active = activePage === number;
    const completed = activePage > number;
    const setPage = () => setActivePage(number);
    const scrollIntoOptions = (0, react_1.useMemo)(() => (number > 1 ? { offset: 300, smooth: false } : undefined), [number]);
    return ((0, jsx_runtime_1.jsxs)(Wrap, { children: [(0, jsx_runtime_1.jsxs)(TitleWrap, Object.assign({ spacing: "small", "$completed": completed || active, onClick: setPage }, { children: [(0, jsx_runtime_1.jsx)(OrderNumber, { children: completed ? (0, jsx_runtime_1.jsx)(StyledSvgCheck, {}) : number }), (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "h2" }, { children: title }))] })), (0, jsx_runtime_1.jsx)(ui_1.FormPage, Object.assign({ scrollIntoOptions: scrollIntoOptions }, { children: (0, jsx_runtime_1.jsx)(Child, Object.assign({ kind: "vertical", spacing: "0rem", "$completed": completed || !active }, { children: children })) }))] }));
}
exports.CheckoutSectionView = CheckoutSectionView;
